// @flow

import React, { useState } from 'react'
import { getUser } from 'Common'
import ResetPasswordModal from 'Modals/ResetPassword'
import BillingSetup from 'Screens/Billing/Setup'

type Props = {
  children: React.Node,
  style: any,
  innerStyle: any,
  maxWidth: any
}

const Screen = ({ children, style, innerStyle, maxWidth }: Props) => {

    const [resetPassword, setResetPassword] = useState(!!getUser().reset_password)
    const [forcePayment, setForcePayment]   = useState(!!getUser().force_payment)

  const onBillingPage = window.location.pathname.includes('/billing')

  if (forcePayment && !onBillingPage) {
    return <BillingSetup onSuccess={() => {
      setForcePayment(false)
      if (window.state && window.state.user) {
        window.state.user.force_payment = false
      }
    }} />
  }

  return (

    <div className="portal-screen" style={style}>

      <div className="portal-screen-inner" style={Object.assign({} , maxWidth && { maxWidth }, innerStyle)}>

        {children}

      </div>

      {resetPassword && (
        <ResetPasswordModal
          onClose={() => setResetPassword(false)}
          forcingReset={true}
        />
      )}

    </div>

  )

}



export default Screen;
